import { render, staticRenderFns } from "./salesprocureStorageHistory.vue?vue&type=template&id=cc5d41b0&scoped=true&"
import script from "./salesprocureStorageHistory.vue?vue&type=script&lang=js&"
export * from "./salesprocureStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./salesprocureStorageHistory.vue?vue&type=style&index=0&id=cc5d41b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5d41b0",
  null
  
)

export default component.exports